import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Message = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.12 2H3.88C2.84 2 2 2.84 2 3.88V16.38C2 17.41 2.84 18.26 3.88 18.26H5.76V21.38C5.76 21.62 5.89 21.83 6.11 21.94C6.2 21.98 6.29 22.01 6.39 22.01C6.52 22.01 6.65 21.97 6.77 21.89L11.6 18.27H20.14C21.17 18.27 22.02 17.43 22.02 16.39V3.88C22.02 2.85 21.18 2 20.14 2H20.12ZM20.74 16.38C20.74 16.72 20.46 17 20.12 17H11.38C11.25 17 11.11 17.04 11 17.12L7 20.12V17.62C7 17.28 6.72 17 6.38 17H3.88C3.54 17 3.26 16.72 3.26 16.38V3.88C3.26 3.54 3.54 3.26 3.88 3.26H20.12C20.46 3.26 20.74 3.54 20.74 3.88V16.38ZM17.62 7.62012H6.38001C6.04001 7.62012 5.76001 7.90012 5.76001 8.24012C5.76001 8.58012 6.04001 8.86012 6.38001 8.86012H17.62C17.96 8.86012 18.24 8.58012 18.24 8.24012C18.24 7.90012 17.96 7.62012 17.62 7.62012ZM7.62 11.3799H16.38C16.72 11.3799 17 11.6599 17 11.9999C17 12.3399 16.72 12.6199 16.38 12.6199H7.62C7.28 12.6199 7 12.3399 7 11.9999C7 11.6599 7.28 11.3799 7.62 11.3799Z"
    />
  </svg>
)

export default withDefaultStyles(Message)
